<template>
  <div v-if="attrs.add" class="mb-4 flex-wrap">
    <v-btn
      v-if="attrs.controls"
      class=" ml-2 mr-2"
      light
      rounded
      x-small
      @click="$emit('toggleEdit')"
      >{{ editMode ? "Close" : "Edit" }}</v-btn
    >

    <v-btn
      v-if="attrs.controls && !editMode"
      class="ml-2 mr-2"
      light
      rounded
      x-small
      @click="$emit('delete')"
      >Delete</v-btn
    >
    <v-btn
      v-if="editMode && attrs.controls"
      class="ml-2"
      light
      rounded
      x-small
      color="amber"
      @click="$emit('update')"
      >Apply</v-btn
    >
  </div>
</template>

<script>
export default {
  name: "ColControls",
  data() {
    return {};
  },
  props: {
    el: {
      type: Object,
      default: () => ({}),
    },
    attrs: {
      type: Object,
      default: () => ({}),
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    hideChildren: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
